/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConstStringRuleArgumentDto
 */
export interface ConstStringRuleArgumentDto {
    /**
     * 
     * @type {string}
     * @memberof ConstStringRuleArgumentDto
     */
    val: string;
}

/**
 * Check if a given object implements the ConstStringRuleArgumentDto interface.
 */
export function instanceOfConstStringRuleArgumentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "val" in value;

    return isInstance;
}

export function ConstStringRuleArgumentDtoFromJSON(json: any): ConstStringRuleArgumentDto {
    return ConstStringRuleArgumentDtoFromJSONTyped(json, false);
}

export function ConstStringRuleArgumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConstStringRuleArgumentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'val': json['val'],
    };
}

export function ConstStringRuleArgumentDtoToJSON(value?: ConstStringRuleArgumentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'val': value.val,
    };
}

